import React, { useContext, useState } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import useTranslation from "next-translate/useTranslation";
import { StoreContext } from "../store";

export default function ImpersonateCard() {
  const store = useContext(StoreContext);
  const { t } = useTranslation("common");
  const [isStopping, setIsStopping] = useState(false);
  const impersonator = store.user?.impersonator?.fullName || store.user?.impersonator?.email;
  const impersonated = store.user?.fullName || store.user?.email;

  async function onStop() {
    setIsStopping(true);
    try {
      const res = await store.user.stopImpersonate();

      if (!res) {
        throw new Error("Failed to stop impersonation");
      }

      if (!res.redirectUrl) {
        throw new Error("No redirect URL provided in the response");
      }

      console.log("Impersonation stopped successfully:", res);
      window.location.href = res.redirectUrl;
    } catch (error) {
      console.error("Error stopping impersonation:", error);
    } finally {
      setIsStopping(false);
    }
  }

  return (
    <Box
      style={{
        backgroundColor: "#fbfbe3",
        borderBottom: "2px solid #fbfbe3",
        color: "#fbfbe3",
        zIndex: 1400,
        padding: "24px 16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "24px",
      }}
    >
      <Typography variant="caption" style={{ color: "#94794f" }}>
        <Typography style={{ fontWeight: "bold" }}>{t("Caution!")}</Typography>{" "}
        {t("You're impersonating {{impersonated}} as {{impersonator}}.", {
          impersonated,
          impersonator,
        })}
      </Typography>
      <Button
        onClick={onStop}
        variant="contained"
        style={{ backgroundColor: "#94794f", color: "#fbfbe3" }}
        disabled={isStopping}
      >
        {isStopping ? t("Stopping impersonation...") : t("Stop Impersonation")}
      </Button>
    </Box>
  );
}
